import React from 'react';
import Icon from '@pushpay/icon';

const KebabIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a2.708 2.708 0 110 5.417A2.708 2.708 0 0112 2zm0 7.292a2.708 2.708 0 110 5.416 2.708 2.708 0 010-5.416zm0 7.291A2.708 2.708 0 1112 22a2.708 2.708 0 010-5.417z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

export default KebabIcon;